export default __webpack_public_path__ + "static/hp-brand-deck-17-b1017f28a6b8c6c4107ec2439e0433ed.png";